function detectLocale() {
  const lang = (
    typeof navigator !== "undefined" && navigator.language
      ? navigator.language
      : "en"
  ).toLowerCase();
  return lang.startsWith("tr") ? "tr" : "en";
}

const locale = detectLocale();

const siteConfig = {
  locale,
  dateLocale: locale === "tr" ? "tr-TR" : "en-US",
  siteName: "Fotogurme",
  apiBaseUrl: "https://api.fotogurme.com",
  gaId: "G-WP8WY6FFJC",
  adsId: "AW-17782760310",
  cdnUrl: "https://cdn.fotogurme.com",
  /** Ana harita marker'larında Cloudflare Image Resizing (küçük görsel). */
  mapMarkerCloudflareResize: true,
};

export default siteConfig;
